import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';

import { refinePrompt } from '~/services/prompt-refinement/prompt-refinement-service';

export const QUERY_KEY_REFINE_PROMPT = 'QUERY_KEY_REFINE_PROMPT';

interface UseRefinePromptQueryParams {
  question: string;
  isEnabled: boolean;
}

export const useRefinePromptQuery = ({
  question,
  isEnabled,
}: UseRefinePromptQueryParams) => {
  const trimmedQuestion = question.trim();

  return useQuery({
    queryKey: [QUERY_KEY_REFINE_PROMPT, trimmedQuestion],
    queryFn: ({ signal }) =>
      refinePrompt({ question: trimmedQuestion, signal }),
    enabled: isEnabled && !!trimmedQuestion,
    staleTime: getTimeTillEndOfDayMs(),
    retry: false,
  });
};
